/**
 * Public permalink: /sport/:gameId/match – match list for a sport. Viewable without login.
 */

import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getPublicMatches } from '../../api/readApi';
import { getGameById } from '../../constants/games';
import PublicLayout from '../../components/PublicLayout';
import { formatDateTime } from '../../utils/dateFormat';
import '../PublicPages.css';

export default function PublicMatchListPage() {
  const { gameId } = useParams();
  const game = getGameById(gameId);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gameId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    getPublicMatches(gameId, null, 50)
      .then((res) => {
        if (cancelled) return;
        setMatches(res?.matches ?? []);
      })
      .catch(() => {
        if (!cancelled) setMatches([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [gameId]);

  if (!game) {
    return (
      <PublicLayout>
        <p>Sport not found.</p>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout title={`${game.icon} ${game.name} – Matches`}>
      <nav className="public-breadcrumb">
        <Link to={`/sport/${gameId}`} className="public-link">← {game.name}</Link>
      </nav>
      <div className="public-card card-ui">
        {loading ? (
          <p className="public-loading">Loading…</p>
        ) : matches.length === 0 ? (
          <p className="public-no-data">No matches yet.</p>
        ) : (
          <ul className="public-match-list">
            {matches.map((m) => (
              <li key={m.id} className="public-match-item">
                <Link to={`/sport/${gameId}/match/${m.id}`} className="public-link public-match-link">
                  <span className="public-match-meta">
                    {m.matchNumber != null ? `Match #${m.matchNumber}` : m.id.slice(0, 8)} · {m.status || 'scheduled'}
                    {m.scheduledAt && (
                      <> · {formatDateTime(m.scheduledAt?.toDate?.() ?? m.scheduledAt)}</>
                    )}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </PublicLayout>
  );
}
